import React, { useState, useEffect, useContext } from 'react';
import {
  Table,
  Stack,
  Button,
  TableRow,
  TableBody,
  TableCell,
  Typography,
  TableContainer,
  Grid,
  CircularProgress,
  Backdrop,
  TextField,
  TableFooter,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MUIDataTable from 'mui-datatables';
import { FetchContext } from 'src/context/FetchContext';
import { API_ROUTES } from 'src/services/constant';
import { useNavigate } from 'react-router-dom';
import Scrollbar from 'src/components/scrollbar';
import Iconify from '../../../iconify';
import { AuthContext } from 'src/context/AuthContext';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { toast } from 'react-hot-toast';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import StaffDwrView from './ManagerDailyWorkReportView';
import SubmitDwrModal from 'src/components/StaffsideComponent/StaffDWR/StaffDwrCreate/submit_dwr_modal';
import NonBillableDWRModal from 'src/components/StaffsideComponent/StaffDWR/StaffDwrCreate/NonBillableDWRForm';

dayjs.extend(utc);
dayjs.extend(timezone);
// mock
const { PRIVATE_ROUTE } = API_ROUTES;

export default function StaffDwrlist() {
  const [open, setOpen] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(null);
  const [disablededit, setDisabledEdit] = useState([]);
  const { authAxios } = useContext(FetchContext);
  const [totalEstimatedHours, setTotalEstimatedHours] = useState(0);
  const [totaltask_hour, setTotalTaskHour] = useState(0);
  const [grandTotalEstimatedHours, setGrandTotalEstimatedHours] = useState(0);
  const [grandTotaltaskHour, setGrandTotalTaskHour] = useState(0);
  const { state } = useContext(AuthContext);
  const [sortEnable, setSortEnable] = useState({});
  const [searchEnable, setSearchEnable] = useState();
  const [selectedstartDate, setselectstartDate] = useState(dayjs().subtract(4, 'day').format('YYYY-MM-DD'));
  const [selectendDate, setselectendDate] = useState(dayjs().format('YYYY-MM-DD'));
  const [isValidDate, setIsValidDate] = useState(false);
  const [isValid, setIsValid] = useState(false);
  const [enbleAcuracy, setEnableAcuracy] = useState(true);
  const [viewDwrOpen, setViewDwrOpen] = useState(false);
  const [selectedDwrId, setSelectedDwrId] = useState(null);
  const [submitDwrOpen, setSubmitDwrOpen] = useState(false);
  const [editDwrSchedule, setEditDwrSchedule] = useState(null);
  const [nonBillableConfirmOpen, setNonBillableConfirmOpen] = useState(false);
  const [nonBillableModalOpen, setNonBillableModalOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  }, []);
  const fetchData = async () => {
    if (state.user.role === 'employee') {
      const postData = {
        employee_id: state.user._id,
      };
      try {
        const response = await authAxios.post(PRIVATE_ROUTE.GET_EMPLOYEES_REPORT, postData);

        response?.data?.data?.forEach((item) => {
          const dwr_labour_cost_item = item?.billing_line_items?.labourCosts[0]?.costitem;
          const task_labour_cost_item = item?.taskdata?.billing_line_items?.labour_item?.labour_cost_items;
        });
        setEnableAcuracy(false);
      } catch (error) {
        console.error('Error fetching employee report:', error);
      }
    }
  };

  function roundToTwo(num) {
    return +(Math.round(num * 100 + 'e+2') + 'e-2');
  }
  const totalAccuracy = roundToTwo(totalEstimatedHours / totaltask_hour);
  const handleViewDwr = (id) => {
    if (!id) return;

    setSelectedDwrId(id);
    setViewDwrOpen(true);
  };

  const handleEditDwr = (schedule) => {
    if (!schedule) {
      return;
    }

    // First close the View DWR modal
    setViewDwrOpen(false);
    setSelectedDwrId(null);

    // Store the schedule for SubmitDwrModal
    setEditDwrSchedule(schedule);

    // Open Submit DWR modal
    setSubmitDwrOpen(true);
  };

  const handleCloseSubmitDwr = () => {
    setSubmitDwrOpen(false);
    setEditDwrSchedule(null);
  };

  const handleDwrSubmitted = async (scheduleId) => {
    setSubmitDwrOpen(false);
    setEditDwrSchedule(null);

    await getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  };

  const handleCloseDwr = () => {
    setViewDwrOpen(false);
    setSelectedDwrId(null);
  };

  const handleDwrViewSuccess = async () => {
    await getUserdata({
      sortField: sortEnable.sortField,
      sortOrder: sortEnable.sortOrder,
      searchQuery: searchEnable,
      page_no: page,
    });
  };


  const handleRowDelete = async (e, id) => {
    if (confirm('Are you sure want to delete?') === true) {
      await authAxios.post(`${PRIVATE_ROUTE?.DELETE_DWR}${id}`);
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
      setOpen(null);
      setSelectedRow(null);
    }
  };

  const handlecreateform = () => {
    setNonBillableConfirmOpen(true);
  };

  const handleNonBillableConfirmClose = () => {
    setNonBillableConfirmOpen(false);
  };

  // No: Continue to the existing DWRForm page
  const handleBillableDwr = () => {
    setNonBillableConfirmOpen(false);
    navigate('/staff/dwr/create');
  };

  // Yes: Open the separate Non-Billable DWR modal
  const handleNonBillableDwr = () => {
    setNonBillableConfirmOpen(false);
    setNonBillableModalOpen(true);

    // The separate Non-Billable DWR modal component
    // will be integrated here when its JS file is created.
  };

  const getUserdata = (query, requestedRowsPerPage = rowsPerPage) => {
    setGrandTotalEstimatedHours(0);
    setGrandTotalTaskHour(0);
    setTotalEstimatedHours(0);
    setTotalTaskHour(0);
    setLoading(true);
    let sort_params;
    let page_cout = query.page_no ? query.page_no : 0;
    let start_date = selectedstartDate !== null ? selectedstartDate : '';
    let end_date = selectendDate !== null ? selectendDate : '';
    let search_query = query.searchQuery ? query.searchQuery : '';
    if (typeof query !== 'string') {
      sort_params = `&startDate=${start_date}&endDate=${end_date}&sortField=${query.sortField}&sortOrder=${query.sortOrder}&search=${search_query}`;
    } else {
      sort_params = `&search=${query}&startDate=${start_date}&endDate=${end_date}`;
    }
    let isMounted = true;
    const getUsers = async () => {
      if (start_date && end_date) {
        if (enbleAcuracy) {
          fetchData();
        }
        const { data } = await authAxios.get(
          `${PRIVATE_ROUTE?.GET_DWR}?page=${page_cout + 1}&per_page=${requestedRowsPerPage}${sort_params}&user_id=${state.user._id
          }`
        );

        if (isMounted) {
          setUsers(
            data?.data?.map((item) => {
              const manager_name = item.project_managers.map(
                (project_manager) => project_manager.first_name + ' ' + project_manager.last_name
              );
              let stausorignal = 'Pending';
              let accuracyPer = 0;
              if (item.status === 1) {
                const estimate_hours = item.billing_line_items?.labourCosts[0]?.estimate_hour ?? 0;
                accuracyPer = roundToTwo(estimate_hours / item.task_hour);

                setTotalEstimatedHours((prevTotal) => prevTotal + (estimate_hours ? parseFloat(estimate_hours) : 0));
                setTotalTaskHour((prevTotal) => prevTotal + parseFloat(item.task_hour));
                stausorignal = 'Approved';
              } else if (item.status === 2) {
                stausorignal = 'Rejected';
              }
              return {
                _id: item._id,
                dwr_number: item?.dwr_number,
                // dwr_number: (
                //   <Link to={`/staff/dwr/view/${item._id}`}>
                //     <b>{item?.dwr_number}</b>
                //   </Link>
                // ),
                client_representative: <b>{item?.client_representative}</b>,
                task_name: item?.taskdata?.number_str,
                job_number: item.job_number,
                project_manager: manager_name.join(', '),
                accuracy: stausorignal === 'Approved' ? accuracyPer + '%' : '-',
                task_hour: item?.task_hour,
                task_estimate_hour:
                  stausorignal === 'Approved' ? item?.billing_line_items?.labourCosts[0]?.estimate_hour : 'NA',

                end_date: item?.end_date,
                remark: item?.remark,
                status: stausorignal,
                task_date: new Date(item?.task_date).toISOString().split('T')[0],
                cost_item: item?.billing_line_items?.labourCosts[0]?.costitem,
              };
            })
          );
          setCount(data.total);
          setLoading(false);
        }
      } else {
        setLoading(false);
        toast.error('Please select date range', { duration: 5000 });
      }
    };

    getUsers().catch((err) => {
      if (!isMounted) return;
      console.error('failed to fetch data', err);
      setLoading(false);
    });
    return () => {
      isMounted = false;
    };
  };

  function handleDateSort() {
    if (selectendDate !== null && selectedstartDate !== null) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
      });
    }
  }

  useEffect(() => {
    if (isValid) {
      getUserdata({
        sortField: sortEnable.sortField,
        sortOrder: sortEnable.sortOrder,
        searchQuery: searchEnable,
        page_no: page,
      });
    }
    setIsValid(false);
  }, [isValid]);

  const columns = [
    {
      name: '_id',
      label: 'Name',
      options: {
        draggable: true,
        sort: false,
        filter: false,
        display: false,
      },
    },
    {
      name: 'dwr_number',
      label: 'DWR#',
      options: {
        draggable: true,
        sort: true,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const status = tableMeta.rowData[9];

          let backgroundColor = '#F59E0B'; // Pending - Amber

          if (status === 'Approved') {
            backgroundColor = '#2E7D32'; // Green
          } else if (status === 'Rejected') {
            backgroundColor = '#D32F2F'; // Red
          }

          return (
            <span
              role="button"
              tabIndex={0}
              onClick={() => handleViewDwr(tableMeta.rowData[0])}
              onKeyDown={(event) => {
                if (event.key === 'Enter' || event.key === ' ') {
                  event.preventDefault();
                  handleViewDwr(tableMeta.rowData[0]);
                }
              }}
              style={{
                display: 'inline-block',
                backgroundColor,
                color: '#fff',
                fontWeight: 'bold',
                fontSize: '11px',
                textDecoration: 'none',
                padding: '2px 5px',
                borderRadius: '3px',
                lineHeight: 1.2,
                cursor: 'pointer',
              }}
            >
              {value}
            </span>
          );
        },
      },
    },
    {
      name: 'task_date',
      label: 'Date',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_name',
      label: 'Task#',
      options: {
        draggable: true,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: `job_number`,
      label: 'Job#',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'project_manager',
      label: 'Project Manager',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'cost_item',
      label: 'Cost Item',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'task_hour',
      label: 'Dwr Hour',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
        customBodyRender: (value, tableMeta) => {
          const color = tableMeta.rowData[9] === 'Approved' ? 'green' : '#212B36';
          const fontWeight = tableMeta.rowData[9] === 'Approved' ? 'bold' : 'normal';
          return <span style={{ color, fontWeight }}>{value}</span>;
        },
      },
    },
    {
      name: 'task_estimate_hour',
      label: 'Task Estimate Hour',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'status',
      label: 'Status',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'accuracy',
      label: 'Accuracy',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: true,
      },
    },
    {
      name: 'remark',
      label: 'Remark',
      options: {
        draggable: false,
        sort: false,
        filter: true,
        display: false,
      },
    },
    {
      name: '',
      label: 'Action',
      options: {
        filter: true,
        display: true,
        sort: false,
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            <div style={{ display: 'flex', gap: '5px' }}>
              <EditIcon
                color={tableMeta.rowData[9] === 'Pending' ? 'inherit' : 'disabled'}
                onClick={
                  tableMeta.rowData[9] === 'Pending'
                    ? () => handleViewDwr(tableMeta.rowData[0])
                    : undefined
                }
              />
              <DeleteIcon
                color={tableMeta.rowData[9] === 'Pending' ? 'inherit' : 'disabled'}
                onClick={
                  tableMeta.rowData[9] === 'Pending' ? (e) => handleRowDelete(e, tableMeta.rowData[0]) : undefined
                }
              />
            </div>
          );
        },
      },
    },
  ];

  const options = {
    selectToolbarPlacement: 'none',
    tableId: 'HelloWorld',
    rowHover: false,
    jumpToPage: true,
    responsive: 'standard',
    print: true,
    fixedHeader: true,
    filter: false,
    count: count,
    pagination: true,
    selectableRows: false,
    downloadOptions: {
      filterOptions: {
        useDisplayedColumnsOnly: true,
      },
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      const formattedData = data.map((item) => {
        if (typeof item === 'string') {
          return item;
        }
        if (typeof item === 'object' && Array.isArray(item.data)) {
          const result = [];

          item.data.forEach((el) => {
            if (typeof el !== 'object') {
              result.push(el);
            }

            if (typeof el === 'object') {
              if (el.props?.to) {
                result.push(el.props.children.props.children);
              }

              if (Array.isArray(el.props?.children)) {
                const childrenArray = el.props.children;
                const combinedString = `${childrenArray[1]}, ${childrenArray[5]}, ${childrenArray[9]}, ${childrenArray[13]}`;
                result.push(combinedString);
              }
            }
          });

          return result;
        }

        return null;
      });
      const result = formattedData.map((data, index) => ({
        index: index,
        data: data,
      }));
      const footerData = ['', '', '', '', '', 'Total Task Hours', `${totaltask_hour}`, ''];
      return `${buildHead(columns)}${buildBody(result)}\n${footerData.join(',')}\n`;
    },
    customToolbar: () => {
      return (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            width: '100%',
            marginBottom: '10px',
            padding: '0 8px',
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontSize: { xs: '1rem', sm: '1.25rem' },
              whiteSpace: 'normal',
            }}
          >
            Total Accuracy : {totalEstimatedHours && totalAccuracy + '%'}
          </Typography>
        </div>
      );
    },
    setRowProps: (row, dataIndex, rowIndex) => {
      return {
        style: {
          backgroundColor: rowIndex % 2 === 0 ? 'rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)' : 'white',
        },
      };
    },
    setTableProps: () => {
      return {
        border: '1px solid rgba(101, 200, 208,0.15) 200, 208,0.15) 200, 208,0.15)',
        size: 'small',
      };
    },
    onSearchChange: (searchQuery) => {
      setSearchEnable(searchQuery);
      if (searchQuery !== null && searchQuery.length > 2) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField;
          const sortOrder = sortEnable.sortOrder;
          getUserdata({ sortField, sortOrder, searchQuery });
        } else {
          getUserdata({ searchQuery });
        }
      }
      if (searchQuery === null) {
        if (Object.keys(sortEnable).length !== 0) {
          const sortField = sortEnable.sortField;
          const sortOrder = sortEnable.sortOrder;
          getUserdata({ sortField, sortOrder });
        } else {
          getUserdata('');
        }
      }
    },

    onChangeRowsPerPage: (numberOfRows) => {
      // Keep the currently selected page.
      // MUIDataTable uses zero-based page numbers.
      const currentPage = page === null || page === undefined ? 0 : page;

      setRowsPerPage(numberOfRows);
      setPage(currentPage);

      getUserdata(
        {
          sortField: sortEnable.sortField,
          sortOrder: sortEnable.sortOrder,
          searchQuery: searchEnable,
          page_no: currentPage,
        },
        numberOfRows
      );
    },

    serverSide: true,

    onTableChange: (action, tableState) => {
      const { name, direction } = tableState.sortOrder || {};

      const sortField = name;
      const sortOrder = direction;
      const searchQuery = searchEnable;
      const page_no = tableState.page;

      if (action === 'sort') {
        setSortEnable({
          sortField,
          sortOrder,
        });

        setPage(page_no);

        getUserdata({
          sortField,
          sortOrder,
          searchQuery,
          page_no,
        });
      } else if (action === 'changePage') {
        setPage(page_no);

        getUserdata({
          sortField,
          sortOrder,
          searchQuery,
          page_no,
        });
      }
    },

    customTableBodyFooterRender: (opts) => {
      return (
        <>
          <TableFooter>
            <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 }, border: '1px solid #808080' }}>
              {opts.columns.map((col, index) => {
                if (col.name === 'dwr_number') {
                  return (
                    <TableCell
                      sx={{
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        border: '1px solid #808080 !important',
                      }}
                      key={index}
                    >
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'task_date') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'task_name') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'job_number') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'project_manager') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'cost_item') {
                  return (
                    <TableCell
                      sx={{
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        border: '1px solid #808080 !important',
                        textAlign: 'end',
                      }}
                      key={index}
                    >
                      Total:
                    </TableCell>
                  );
                }
                if (col.name === 'task_hour') {
                  return (
                    <TableCell
                      sx={{
                        color: 'black',
                        fontWeight: 'bold',
                        fontSize: '18px',
                        border: '1px solid #808080 !important',
                      }}
                      key={index}
                    >
                      {totaltask_hour}
                    </TableCell>
                  );
                }
                if (col.name === 'task_estimate_hour') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'status') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === 'accuracy') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
                if (col.name === '') {
                  return (
                    <TableCell sx={{ border: '1px solid #808080 !important' }} key={index}>
                      { }
                    </TableCell>
                  );
                }
              })}
            </TableRow>
          </TableFooter>
        </>
      );
    },
  };

  return (
    <>
      <Grid sx={{ p: { xs: 2, sm: 3, md: 4 }, pb: 0 }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          alignItems={{ xs: 'stretch', sm: 'center' }}
          justifyContent="space-between"
          spacing={2}
          mb={2}
        >
          <Typography variant="h4" gutterBottom sx={{ mb: 0 }}>
            Daily Work Report
          </Typography>

          <Button
            variant="contained"
            onClick={handlecreateform}
            startIcon={<Iconify icon="eva:plus-fill" />}
            sx={{
              width: { xs: '100%', sm: 'auto' },
            }}
          >
            New Daily Work Report
          </Button>
        </Stack>
        <Grid
          container
          spacing={2}
          sx={{
            py: 2,
            alignItems: 'center',
            width: '100%',
            m: 0,
          }}
        >
          <Grid item xs={12} sm={6} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="Start Date"
                value={selectedstartDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectstartDate(formattedDate);
                }}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    fullWidth
                  />
                )}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm={6} md={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                label="End Date"
                value={selectendDate}
                inputFormat="YYYY-MM-DD"
                onChange={(value) => {
                  const formattedDate = dayjs(value).format('YYYY-MM-DD');
                  setselectendDate(formattedDate);
                }}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    fullWidth
                  />
                )}
                minDate={selectedstartDate}
                onError={(newError) => setIsValidDate(newError)}
              />
            </LocalizationProvider>
          </Grid>
          <Grid item xs={12} sm="auto">
            <Button
              size="large"
              type="submit"
              variant="contained"
              onClick={handleDateSort}
              disabled={selectendDate === null || selectedstartDate === null}
              sx={{
                width: { xs: '100%', sm: 'auto' },
              }}
            >
              Submit
            </Button>
          </Grid>
        </Grid>
        <Grid sx={{ width: '100%', overflow: 'hidden' }}>
          <Scrollbar>
            <TableContainer
              sx={{
                width: '100%',
                overflowX: 'auto',
                WebkitOverflowScrolling: 'touch',
              }}
            >
              <Table>
                {loading && (
                  <div>
                    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
                      <CircularProgress color="inherit" />
                    </Backdrop>
                  </div>
                )}
                <MUIDataTable
                  options={options}
                  columns={columns}
                  data={users}
                />
                {!users && !loading && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        No Data Found
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>
        </Grid>
      </Grid>

      <StaffDwrView
        open={viewDwrOpen}
        onClose={handleCloseDwr}
        id={selectedDwrId}
        onSuccess={handleDwrViewSuccess}
        onEdit={handleEditDwr}
      />
      <NonBillableDWRModal
        open={nonBillableModalOpen}
        onClose={() => setNonBillableModalOpen(false)}
        onSuccess={() => {
          setNonBillableModalOpen(false);
          // Refresh the DWR list here if needed.
        }}
      />
      <SubmitDwrModal
        open={submitDwrOpen}
        selectedWork={
          editDwrSchedule
            ? {
              type: 'schedule',
              schedule: editDwrSchedule,
            }
            : null
        }
        dwrNumber={editDwrSchedule?.dwr_id || ''}
        taskNumber={
          editDwrSchedule?.task?.number_str ||
          editDwrSchedule?.task?.number ||
          ''
        }
        costItem={editDwrSchedule?.costItem || ''}
        onClose={handleCloseSubmitDwr}
        onDwrSubmitted={handleDwrSubmitted}
      />
      <Dialog
        open={nonBillableConfirmOpen}
        onClose={handleNonBillableConfirmClose}
        fullWidth
        maxWidth="xs"
      >
        <DialogTitle>Confirm Daily Work Report</DialogTitle>

        <DialogContent>
          <DialogContentText>
            Do you want to submit a Non-Billable DWR?
          </DialogContentText>
        </DialogContent>

        <DialogActions sx={{ p: 2 }}>
          <Button
            variant="outlined"
            onClick={handleBillableDwr}
          >
            No
          </Button>

          <Button
            variant="contained"
            onClick={handleNonBillableDwr}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

